// ** Third Party Imports
import styled from 'styled-components'

// ** Component Imports
import { Typography } from '@/shared/ui'

// ** Utility Imports
import { media } from '@/shared/styles'

export const FooterWrapper = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	background: #ecf2f0;
	padding-bottom: 7rem;
	margin: 0 auto;
	margin-top: 8rem;
	max-width: 74rem;

	${media.xl} {
		max-width: 64rem;
	}

	${media.lg} {
		max-width: 48rem;
	}

	${media.md} {
		max-width: 34rem;
		text-align: center;
		flex-direction: column;
		row-gap: 1.25rem;
		margin-top: 4rem;
		padding-bottom: 4rem;
	}

	${media.sm} {
		max-width: 25rem;
	}

	${media.xs} {
		max-width: 21rem;
		margin-top: 4rem;
	}
`

export const LogoWrapper = styled.div`
	order: 2;
	margin-left: 15%;

	${media.md} {
		order: 1;
		margin-left: 0;
	}
`

export const SocialsWrapper = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	column-gap: 0.7rem;
	order: 1;

	${media.md} {
		order: 2;
	}
`

export const RightsWrapper = styled.div`
	display: flex;
	flex-direction: row;
	align-items: bottom;
	column-gap: 0.65rem;
	order: 3;

	${media.md} {
		order: 3;
	}
`

export const AllRightsReserved = styled(Typography)`
	font-family: 'Fustat', sans-serif;
	font-optical-sizing: auto;
	font-style: normal;
	color: #00000077;
	font-size: 0.9rem;
	margin-top: 0.25rem;
`
